import { usePartners } from '../api/getPartners';
import { Spinner } from 'components/Elements';

export const Partners = () => {
  const { data, isLoading } = usePartners();

  if (isLoading) {
    return (
      <section className="py-16 text-center">
        <Spinner size="lg" />
      </section>
    );
  }

  const partners = data?.data?.filter((p) => p.isActive) || [];
  if (partners.length === 0) return null;

  return (
    <section className="py-16 bg-white">
      <div className="px-6 sm:px-12 lg:px-48">
        {/* Header */}
        <div className="text-start mb-10">
          <h2 className="text-2xl sm:text-5xl font-semibold text-[#F8AF10] just-me-again-down-here-regular mb-4">
            Trusted by Our Partners
          </h2>
          <p className="text-sm sm:text-base text-gray-800 mb-8 leading-relaxed max-w-2xl">
            We collaborate with brands and organisations that share our values.
          </p>
        </div>

        {/* Logos */}
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-8 items-center">
          {partners.map((partner) => (
            <div
              key={partner._id}
              className="flex items-center justify-center opacity-70 hover:opacity-100 transition"
            >
              {partner.logo ? (
                <img
                  src={partner.logo}
                  alt={partner.name}
                  className="h-24 md:h-32 object-contain grayscale hover:grayscale-0 transition"
                />
              ) : (
                <span className="text-sm font-medium text-gray-400">{partner.name}</span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
